import { t } from 'i18next';

import * as State from 'components/desktop/Accessory/AccessoryState';
import { IconsBar } from 'components/desktop/Recipe/IconsBar/IconsBar';
import Co2Display from 'components/desktop/_general/Co2Display/Co2Display';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import DetailHeader from 'components/desktop/_general/DetailHeader/DetailHeader';
import ENTITLEMENTS from 'enums/entitlements';
import * as Image from 'types/Media/Image';
import * as TagList from 'types/_general/Store/TagList';

interface IProps {
	allTags: TagList.Type;
	cultureCode: string;
	handleSave: () => void;
	id: string | null;
	image: Image.Type | null;
	isLoading: boolean;
	readOnly: boolean;
	state: State.Type;
}

const AccessoryHeader = (props: IProps) => {
	const getTitle = (): string => {
		if (props.state.nameSingular[props.cultureCode])
			return props.state.nameSingular[props.cultureCode];
		if (!props.id) return t('accessory:NEW_ACCESSORY');
		if (props.readOnly) return t('accessory:VIEW_ACCESSORY');
		return t('accessory:EDIT_ACCESSORY');
	};

	const renderBottomArea = (): JSX.Element => {
		return (
			<div
				className="d-flex flex-row justify-content-between align-items-end flex-grow-1"
				style={{ gap: '15px' }}
			>
				<IconsBar tags={TagList.getFromIdArray(props.allTags, props.state.tagIds)} />
				<div className="d-flex">
					<RenderIf entitlements={[ENTITLEMENTS.CARBONDIOXIDE]}>
						<Co2Display
							value={props.state.carbonDioxideValue}
							color={props.state.carbonDioxideLabel?.color || '#000'}
							fluid={props.state.characteristic}
							valueScopeInfo={null}
						/>
					</RenderIf>
				</div>
			</div>
		);
	};

	return (
		<DetailHeader
			handleSave={props.handleSave}
			title={getTitle()}
			image={props.image}
			isLoading={props.isLoading}
			readOnly={props.readOnly}
			bottomArea={renderBottomArea()}
		/>
	);
};

export default AccessoryHeader;
